import axios from 'axios';

export const baseURL = process.env.VUE_APP_API_BASE_URL || (process.env.NODE_ENV === 'production' ? 'https://cogzb-api.scszsj.com' : '');

const TOKEN_KEY = 'logintoken';
const USER_KEY = 'userInfo';

const getToken = () => localStorage.getItem(TOKEN_KEY) || '';

const getAuthorizationValue = () => {
  const token = getToken();

  if (!token) {
    return '';
  }

  return /^Bearer\s/i.test(token) ? token : `Bearer ${token}`;
};

const createHeaders = (options = {}) => {
  const settings = Object.assign({
    withAuth: true,
    contentType: 'application/json',
    extra: {}
  }, options);

  const headers = Object.assign({
    Accept: 'application/json'
  }, settings.extra);

  if (settings.contentType) {
    headers['Content-Type'] = settings.contentType;
  }

  if (settings.withAuth) {
    const authorization = getAuthorizationValue();

    if (authorization) {
      headers.Authorization = authorization;
    }
  }

  return headers;
};

const clearAuthAndRedirect = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);

  if (typeof window !== 'undefined') {
    const { protocol, host } = window.location;
    window.location.href = `${protocol}//${host}/#/login`;
  }
};

const isUnauthorized = (error, errorMsg) => {
  if (error && error.response && error.response.status === 401) {
    return true;
  }

  const message = errorMsg && (errorMsg.message || errorMsg.detail);
  return message === 'Unauthenticated.' || message === '无效的令牌格式' || message === '令牌已过期' || message === 'Not authenticated';
};

const resolveResponse = res => {
  if (res.status === 204) {
    return 204;
  }

  if (res.status >= 200 && res.status < 300) {
    return res.data;
  }

  return Promise.reject(res.data);
};

const handleError = error => {
  const errorMsg = error.response ? error.response.data : '请求失败，请检查网络或参数';

  if (isUnauthorized(error, errorMsg)) {
    clearAuthAndRedirect();
  }

  return errorMsg;
};

// 登录请求方法
const loginreq = (method, url, params) => {
  return axios({
    method: method,
    url: baseURL + url,
    headers: createHeaders({ withAuth: false }),
    data: params,
  }).then(resolveResponse)
    .catch(handleError);
};

// 通用公用方法
const req = (method, url, params) => {
  return axios({
    method: method,
    url: baseURL + url,
    headers: createHeaders(),
    data: params,
  }).then(resolveResponse)
    .catch(handleError);
};

// GET请求方法
const reqs = (method, url, params) => {
  return axios({
    method: method,
    url: baseURL + url,
    headers: createHeaders({ contentType: null }),
    params: params,
  }).then(resolveResponse)
    .catch(handleError);
};

// Upload文件上传 参数在body中
const upload = (method, url, params) => {
  return axios({
    method: method,
    url: baseURL + url,
    headers: createHeaders({ contentType: 'multipart/form-data' }),
    data: params,
  }).then(resolveResponse)
    .catch(handleError);
};

export {
    loginreq,
    req,
    reqs,
    upload
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js